import React from "react";
import { Box, Spacer, Stack, Typography } from "digiwash-components";
import Header from "../components/AppHeader";
import PageContainer from "../components/PageContainer";
import useBack from "../hooks/useBack";
import { formatPrice } from "digiwash-core";
import useProfile from "../ducks/user/hooks/useProfile";
import TransactionsCard from "../containers/TransactionsCard";
import { Helmet } from "react-helmet";
import HeaderContainer from "../containers/HeaderContainer";

function UserTransactionsList() {
  let { data } = useProfile();
  let back = useBack();
  return (
    <>
      <Helmet>
        <title>تراکنش ها | دیجی واش</title>
      </Helmet>
      <PageContainer
        bg="common.white"
        insideBeignScrollView={
          <HeaderContainer>
            <Header title="تراکنش های اعتباری" onBack={back} />
          </HeaderContainer>
        }
      >
        <Box px="l" pt="xxl">
          <Box p="l" br="l" bg="primary.light940">
            <Stack distribution="space-between">
              <Typography color="common.black" ff="mainMedium" fs="m">
                مانده اعتبار
              </Typography>
              <Stack>
                <Typography color="common.black" ff="mainMedium">
                  {formatPrice(data.total_balance)}
                </Typography>
                <Spacer size="s" />
                <Typography ff="mainMedium" color="common.black" fs="s">
                  تومان
                </Typography>
              </Stack>
            </Stack>
          </Box>
          <TransactionsCard />
        </Box>
      </PageContainer>
    </>
  );
}

export default UserTransactionsList;
